'use client';

import { LoginForm } from "@/components/auth-related/login-form";
import Image from 'next/image';
import Link from 'next/link';
import { useTheme } from 'next-themes';
import { useSyncExternalStore } from 'react';

export function LoginContent({ nextPath }: { nextPath: string }) {
  const { resolvedTheme } = useTheme();
  const mounted = useSyncExternalStore(() => () => { }, () => true, () => false);

  return (
    <div className="bg-muted p-4 min-h-svh">
      <div className="flex items-center gap-2 self-center font-medium">
        {mounted && (
          <Image
            src={resolvedTheme === 'dark' ? '/images/logo-dark.webp' : '/images/logo.webp'}
            alt="Logo"
            width={96}
            height={38}
            style={{ height: 'auto' }}
          />
        )}
      </div>
      <div className="flex flex-col items-center justify-center gap-6 p-6 md:p-10">
        <div className="flex w-full max-w-sm flex-col gap-6">

          <LoginForm nextPath={nextPath} />
        </div>


        <div
          aria-hidden="true"
          className="-z-10 pointer-events-none absolute left-0 top-0 w-full bg-gradient-overlay"
          style={{
            height: "100vh",
            transform: "rotate(180deg)"
          }}
        ></div>
      </div>
    </div>
  );
}
